<template>
<div class="schulte-out">
  <div class="schulte-cont">
    <div class="grid-5">
      <div
        v-for="(item, index) in cells"
        :key="index"
        class="cell"
        :class="{'done': item.done, 'wrong': item.wrong}"
        @click="onCell(item)"
      >{{ item.num }}</div>
    </div>
    <div class="info">
      <span>下一个数字：{{ nextNum > max ? '完成' : nextNum }}</span>
      <span>用时：{{ formatTime(time) }}</span>
      <button class="btn" @click="start">{{ running ? '重新开始' : '开始' }}</button>
    </div>
    <score-modal
      :visible="showResult"
      :time="time"
      :records="latest5"
      :percentile="resultPercentile"
      :first="resultFirst"
      :title="modeName"
      @close="closeResult"
    />
  </div>
</div>
</template>

<script>
import schulteMixin from './schulteMixin'
export default {
  name: 'schulte-5x5',
  mixins: [schulteMixin],
  data () {
    return {
      modeKey: '5x5-square',
      modeName: '5×5 方形',
      size: 5,
      cells: [],
      nextNum: 1,
      max: 25,
      startTime: 0,
      time: 0,
      running: false,
      timer: null
    }
  },
  mounted () {
    this.reset()
  },
  methods: {
    reset () {
      const nums = []
      for (let i = 1; i <= this.max; i++) nums.push(i)
      this.shuffle(nums)
      this.cells = nums.map(n => ({ num: n, done: false, wrong: false }))
      this.nextNum = 1
      this.time = 0
      this.running = false
      clearInterval(this.timer)
    },
    start () {
      this.reset()
      this.running = true
      this.startTime = Date.now()
      this.timer = setInterval(() => {
        this.time = (Date.now() - this.startTime) / 1000
      }, 100)
    },
    onCell (item) {
      if (!this.running) return
      if (item.num === this.nextNum) {
        item.done = true
        this.nextNum++
        if (this.nextNum > this.max) {
          clearInterval(this.timer)
          this.running = false
          this.time = (Date.now() - this.startTime) / 1000
          this.schulteFinish()
        }
      } else {
        item.wrong = true
        setTimeout(() => { item.wrong = false }, 300)
      }
    },
    shuffle (arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const tmp = arr[i]
        arr[i] = arr[j]
        arr[j] = tmp
      }
    },
    formatTime (t) {
      return t.toFixed(1) + ' s'
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.schulte-out{
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.schulte-cont{
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px 12px 40px;
  box-sizing: border-box;
}
.grid-5{
  width: 94vw;
  max-width: 376px;
  aspect-ratio: 1 / 1;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 6px;
  background-color: #f5f5f5;
  padding: 6px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  box-sizing: border-box;
}
.cell{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: #{'clamp(16px, 5.2vw, 26px)'};
  font-weight: bold;
  color: #333;
  background-color: #fff;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  transition: background-color 0.15s, color 0.15s, transform 0.1s;
  &:active{
    background-color: #e3f2fd;
  }
  &.done{
    background-color: #4caf50;
    color: #fff;
  }
  &.wrong{
    background-color: #ff5252;
    color: #fff;
    transform: scale(0.96);
  }
}
.info{
  margin-top: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: #{'clamp(13px, 3.6vw, 16px)'};
  color: #333;
  flex-wrap: wrap;
  justify-content: center;
}
.btn{
  padding: 8px 18px;
  font-size: 14px;
  background-color: #2196f3;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:active{
    background-color: #1e88e5;
  }
}
</style>
